import ReportsSerializer from './base';

export default class StudentReportSection extends ReportsSerializer {}
